import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import BillBoard from '../advertisements/BillBoard';
import { connect } from 'react-redux'
import { TitleHeading } from '../UIElements/headings/TitleHeading';
import { LinkButton } from '../UIElements/Link_Button/LinkButton';
import { ButtonStyle } from '../UIElements/Buttons/ButtonStyle';
import authservice from '../Authentication/service/authservice';
import './css/UserProfile.css'
import Popup from "reactjs-popup";
import styles from '../listings/forms/addpost.module.css';
import LargeRectangle from '../advertisements/LargeRectangle';

class Qualification extends Component {

    constructor(props) {
        super(props);
        this.state = {
            myPages: false,
            myVideos: false,
            myReviews: false,
            myPhotos: false,
            myAlbum: false,
            myClips: false,
            isPagesPopupOpen: false,
            isVideosPopupOpen: false,
            isReviewsPopupOpen: false,
            isPhotosPopupOpen: false,
            isAlbumPopupOpen: false,
            isClipsPopupOpen: false,
        }
    }

    componentDidMount() {
        this.handlQualification()
    }

    applyPagePopup = () => {
        this.setState((prevState) => ({
            isPagesPopupOpen: !prevState.isPagesPopupOpen,
        }));
    };
    applyVideoPopup = () => {
        this.setState((prevState) => ({
            isVideosPopupOpen: !prevState.isVideosPopupOpen,
        }));
    };
    applyReviewPopup = () => {
        this.setState((prevState) => ({
            isReviewsPopupOpen: !prevState.isReviewsPopupOpen,
        }));
    };
    applyPhotoPopup = () => {
        this.setState((prevState) => ({
            isPhotosPopupOpen: !prevState.isPhotosPopupOpen
        }));
    };
    applyAlbumPopup = () => {
        this.setState((prevState) => ({
            isAlbumPopupOpen: !prevState.isAlbumPopupOpen
        }));
    };
    applyClipPopup = () => {
        this.setState((prevState) => ({
            isClipsPopupOpen: !prevState.isClipsPopupOpen
        }));
    };


    handlQualification = () => {
        const userId = authservice.getCurrentUserid()
        axios.get(process.env.REACT_APP_BACKEND_URL + `/abmgr/user/get-content-approval-status/${userId}`)
            .then((response) => {
                const pages = response.data.approvalForMyPages
                this.setState({ myPages: pages })

                const videos = response.data.approvalForMyVideos
                this.setState({ myVideos: videos })

                const reviews = response.data.approvalForMyReviews
                this.setState({ myReviews: reviews })

                const photos = response.data.approvalForMyPhotos
                this.setState({ myPhotos: photos })

                const album = response.data.approvalForMyAlbum
                this.setState({ myAlbum: album })

                const clips = response.data.approvalForMyClips
                this.setState({ myClips: clips })
            })
            .catch((error) => {
                console.error(error);
            });
    };


    render() {
        return (
            <>
                <div className="row col-md-12 text-center">
                    <div className="col-md-4"></div>
                    <div className='col-md-4 text-left'>
                        <TitleHeading style={{ marginTop: '20px', marginBottom: '20px', fontSize: '24px' }} text={'Pre-Qualification Test for Content Creators.'} />
                        <ul style={{ fontSize: '22px' }}>
                            {console.log(this.state.myPages)}
                            {this.state.myPages ? <li>
                                <p><i className="fa fa-check-square-o" aria-hidden="true"></i>&nbsp; &nbsp;AajuBaaju My Pages&nbsp;<i style={{ fontSize: '16px', color: '#138808', fontWeight: '700' }}>Qualified</i></p>
                            </li> : <li>
                                <p><i className="fa fa-square-o" aria-hidden="true"></i>&nbsp; &nbsp;AajuBaaju My Pages <LinkButton handleClick={this.applyPagePopup}>Apply Here</LinkButton></p>
                                {this.state.isPagesPopupOpen && (
                                    <Popup
                                        open={this.state.isPagesPopupOpen}
                                        overlayStyle={{ background: 'rgba(0,0,0,0.95)' }}
                                        contentStyle={{ width: "75%", borderRadius: '10px', overflow: 'scroll' }}
                                    >
                                        <div className='popup_height'>
                                            <div className='text-center' key="message">
                                                <TitleHeading text={'Qualification Test to post in AajuBaaju My Pages:'} />
                                                <div className="col-md-12 text-left">
                                                    <p>Submit an article following the guidelines to moderation@aajubaaju.in. Send your blog or website link, if you are an existing content creator.</p>
                                                    <p>Guidelines:<br></br>
                                                        1. Write a short bio in 100 words and submit along with the article.<br></br>
                                                        2. Articles can be in English, Hindi and Telugu languages.<br></br>
                                                        3. Submit quality article which will be helpful for the society with good grammar and correct spellings.<br></br>
                                                        4. Send a thumbnail image in 425px X 425px dimension along with the qualification article.<br></br>
                                                        5.  Do not copy partial content from multiple websites and create a page.<br></br>
                                                        6. AI tools can be used to rewrite the content, but not to write the whole content. If AI tool is used, attach the draft of the content given in the prompt for rewriting.<br></br>
                                                        7. In case of a review, add a photo of the product or place in 800px X 600px in the article. </p>
                                                    <p><strong>Note:</strong> AajuBaaju My Pages/Reviews qualification has only 2 attempts.<br></br>
                                                        Once qualified, you will be able to post Pages/Reviews in aajubaaju.in account and earn an AD revenue share. For any queries, message to 8341370819.</p>
                                                </div>
                                                <ButtonStyle style={{ height: '40px' }} text={'Close'} className="btn" handleClick={this.applyPagePopup}></ButtonStyle>
                                            </div>
                                        </div>
                                    </Popup>
                                )}
                            </li>}

                            {this.state.myVideos ? <li>
                                <p><i className="fa fa-check-square-o" aria-hidden="true"></i>&nbsp; &nbsp;AajuBaaju My Videos &nbsp;<i style={{ fontSize: '16px', color: '#138808', fontWeight: '700' }}>Qualified</i></p>
                            </li> : <li>
                                <p><i className="fa fa-square-o" aria-hidden="true"></i>&nbsp; &nbsp;AajuBaaju My Videos<LinkButton handleClick={this.applyVideoPopup}>Apply Here</LinkButton></p>
                                {this.state.isVideosPopupOpen && (
                                    <Popup
                                        open={this.state.isVideosPopupOpen}
                                        overlayStyle={{ background: 'rgba(0,0,0,0.95)' }}
                                        contentStyle={{ width: "75%", borderRadius: '10px', overflow: 'scroll' }}
                                    >
                                        <div className='popup_height'>
                                            <div className='text-center' key="message">
                                                <TitleHeading text={'Qualification Test to post in AajuBaaju My Videos:'} />
                                                <div className="col-md-12 text-left">
                                                    <p>Submit a Video following the guidelines to moderation@aajubaaju.in. Send your video channel link, if you are an existing video content creator.</p>
                                                    <p>Guidelines:<br></br>
                                                        1. Videos should be in horizontal orientation.<br></br>
                                                        2.The video length should be a minimum of 2 minutes.<br></br>
                                                        3. The video file size can be a maximum of 500MB.<br></br>
                                                        4. The video should be between 360p and of 720p quality.<br></br>
                                                        4. Send a thumbnail image in 1200px X 630px dimension along with the qualification video.<br></br>
                                                        5. Do not copy video belonging to others from the internet or from any other media.</p>
                                                    <p><strong>Note:</strong> AajuBaaju My Videos qualification has only 3 attempts.<br></br>
                                                        Once qualified, you will be able to post clips in aajubaaju.in account and earn an AD revenue share. For any queries, message to 8341370819.</p>
                                                </div>
                                                <ButtonStyle style={{ height: '40px' }} text={'Close'} className="btn" handleClick={this.applyVideoPopup}></ButtonStyle>
                                            </div>
                                        </div>
                                    </Popup>
                                )}
                            </li>}

                            {this.state.myReviews ? <li>
                                <p><i className="fa fa-check-square-o" aria-hidden="true"></i>&nbsp; &nbsp;AajuBaaju My Reviews&nbsp;<i style={{ fontSize: '16px', color: '#138808', fontWeight: '700' }}>Qualified</i></p>
                            </li> : <li>
                                <p><i className="fa fa-square-o" aria-hidden="true"></i>&nbsp; &nbsp;AajuBaaju My Reviews <LinkButton handleClick={this.applyReviewPopup}>Apply Here</LinkButton></p>
                                {this.state.isReviewsPopupOpen && (
                                    <Popup
                                        open={this.state.isReviewsPopupOpen}
                                        overlayStyle={{ background: 'rgba(0,0,0,0.95)' }}
                                        contentStyle={{ width: "75%", borderRadius: '10px', overflow: 'scroll' }}
                                    >
                                        <div className='popup_height'>
                                            <div className='text-center' key="message">
                                                <TitleHeading text={'Qualification Test to post in AajuBaaju My Reviews:'} />
                                                <div className="col-md-12 text-left">
                                                    <p>Submit an article following the guidelines to moderation@aajubaaju.in. Send your blog or website link, if you are an existing content creator.</p>
                                                    <p>Guidelines:<br></br>
                                                        1. Write a short bio in 100 words and submit along with the article.<br></br>
                                                        2. Articles can be in English, Hindi and Telugu languages.<br></br>
                                                        3. Submit quality article which will be helpful for the society with good grammar and correct spellings.<br></br>
                                                        4. Send a thumbnail image in 425px X 425px dimension along with the qualification article.<br></br>
                                                        5.  Do not copy partial content from multiple websites and create a page.<br></br>
                                                        6. AI tools can be used to rewrite the content, but not to write the whole content. If AI tool is used, attach the draft of the content given in the prompt for rewriting.<br></br>
                                                        7. In case of a review, add a photo of the product or place in 800px X 600px in the article. </p>
                                                    <p><strong>Note:</strong> AajuBaaju My Pages/Reviews qualification has only 2 attempts.<br></br>
                                                        Once qualified, you will be able to post Pages/Reviews in aajubaaju.in account and earn an AD revenue share. For any queries, message to 8341370819.</p>
                                                </div>
                                                <ButtonStyle style={{ height: '40px' }} text={'Close'} className="btn" handleClick={this.applyReviewPopup}></ButtonStyle>
                                            </div>
                                        </div>
                                    </Popup>
                                )}
                            </li>}

                            {this.state.myPhotos ? <li>
                                <p><i className="fa fa-check-square-o" aria-hidden="true"></i>&nbsp; &nbsp;AajuBaaju My Photos&nbsp;<i style={{ fontSize: '16px', color: '#138808', fontWeight: '700' }}>Qualified</i></p>
                            </li> : <li>
                                <p><i className="fa fa-square-o" aria-hidden="true"></i>&nbsp; &nbsp;AajuBaaju My Photos <LinkButton handleClick={this.applyPhotoPopup}>Apply Here</LinkButton></p>
                                {this.state.isPhotosPopupOpen && (
                                    <Popup
                                        open={this.state.isPhotosPopupOpen}
                                        overlayStyle={{ background: 'rgba(0,0,0,0.95)' }}
                                        contentStyle={{ width: "75%", borderRadius: '10px', overflow: 'scroll' }}
                                    >
                                        <div className='popup_height'>
                                            <div className='text-center' key="message">
                                                <TitleHeading text={'Qualification Test to post in AajuBaaju My Photos:'} />
                                                <div className="col-md-12 text-left">
                                                    <p>Submit an photo story or a personal album following the guidelines to moderation@aajubaaju.in.</p>
                                                    <p>AajuBaaju My Photos is to share their product catalogue, commercial event photos etc. While AajuBaaju My Albums is to share personal event photos. Note that all photos are visible to all visitors visiting the platform.</p>
                                                    <p>Guidelines:<br></br>
                                                        1. Submit a photo story with minimum 10 photos.<br></br>
                                                        2. Send a thumbnail image in 425px X 425px dimension along with the qualification photo story.<br></br>
                                                        3. Do not send photos belonging to others from the internet or from any other media.</p>
                                                    <p><strong>Note:</strong> AajuBaaju My Photos/Albums qualification has only 2 attempts.<br></br>
                                                        Once qualified, you will be able to post Pages/Reviews in aajubaaju.in account and earn an AD revenue share. For any queries, message to 8341370819.</p>
                                                </div>
                                                <ButtonStyle style={{ height: '40px' }} text={'Close'} className="btn" handleClick={this.applyPhotoPopup}></ButtonStyle>
                                            </div>
                                        </div>
                                    </Popup>
                                )}
                            </li>}

                            {this.state.myAlbum ? <li>
                                <p><i className="fa fa-check-square-o" aria-hidden="true"></i>&nbsp; &nbsp;AajuBaaju My Album&nbsp;<i style={{ fontSize: '16px', color: '#138808', fontWeight: '700' }}>Qualified</i></p>
                            </li> : <li>
                                <p><i className="fa fa-square-o" aria-hidden="true"></i>&nbsp; &nbsp;AajuBaaju My Album <LinkButton handleClick={this.applyAlbumPopup}>Apply Here</LinkButton></p>
                                {this.state.isAlbumPopupOpen && (
                                    <Popup
                                        open={this.state.isAlbumPopupOpen}
                                        overlayStyle={{ background: 'rgba(0,0,0,0.95)' }}
                                        contentStyle={{ width: "75%", borderRadius: '10px', overflow: 'scroll' }}
                                    >
                                        <div className='popup_height'>
                                            <div className='text-center' key="message">
                                                <TitleHeading text={'Qualification Test to post in AajuBaaju My Albums:'} />
                                                <div className="col-md-12 text-left">
                                                    <p>Submit an photo story or a personal album following the guidelines to moderation@aajubaaju.in.</p>
                                                    <p>AajuBaaju My Photos is to share their product catalogue, commercial event photos etc. While AajuBaaju My Albums is to share personal event photos. Note that all photos are visible to all visitors visiting the platform.</p>
                                                    <p>Guidelines:<br></br>
                                                        1. Submit a photo story with minimum 10 photos.<br></br>
                                                        2. Send a thumbnail image in 425px X 425px dimension along with the qualification photo story.<br></br>
                                                        3. Do not send photos belonging to others from the internet or from any other media.</p>
                                                    <p><strong>Note:</strong> AajuBaaju My Photos/Albums qualification has only 2 attempts.<br></br>
                                                        Once qualified, you will be able to post Pages/Reviews in aajubaaju.in account and earn an AD revenue share. For any queries, message to 8341370819.</p>
                                                </div>
                                                <ButtonStyle style={{ height: '40px' }} text={'Close'} className="btn" handleClick={this.applyAlbumPopup}></ButtonStyle>
                                            </div>
                                        </div>
                                    </Popup>
                                )}
                            </li>}

                            {this.state.myClips ? <li>
                                <p><i className="fa fa-check-square-o" aria-hidden="true"></i>&nbsp; &nbsp;AajuBaaju My Clips &nbsp;<i style={{ fontSize: '16px', color: '#138808', fontWeight: '700' }}>Qualified</i></p>
                            </li> : <li>
                                <p><i className="fa fa-square-o" aria-hidden="true"></i>&nbsp; &nbsp;AajuBaaju My Clips <LinkButton handleClick={this.applyClipPopup}>Apply Here</LinkButton></p>
                                {this.state.isClipsPopupOpen && (
                                    <Popup
                                        open={this.state.isClipsPopupOpen}
                                        overlayStyle={{ background: 'rgba(0,0,0,0.95)' }}
                                        contentStyle={{ width: "75%", borderRadius: '10px', overflow: 'scroll' }}
                                    >
                                        <div className='popup_height'>
                                            <div className='text-center' key="message">
                                                <TitleHeading text={'Qualification Test to post in AajuBaaju My Clips:'} />
                                                <div className="col-md-12 text-left">
                                                    <p>Submit a Clip link following the guidelines to moderation@aajubaaju.in</p>
                                                    <p>Guidelines:<br></br>
                                                        1. Videos should be in vertical orientation.<br></br>
                                                        2. The video length should be a MAXIMUM of 2 minutes and MINIMUM 15 Seconds.<br></br>
                                                        3. The video file size can be a maximum of 200MB.<br></br>
                                                        4. Send a thumbnail image in 540px X 960px dimension along with the qualification clip.<br></br>
                                                        5. Do not copy video clip belonging to others from the internet or from any other media.</p>
                                                    <p><strong>Note:</strong> AajuBaaju My Clips qualification has 3 attempts.<br></br>
                                                        Once qualified, you will be able to post clips in aajubaaju.in account and earn an AD revenue share. For any queries, message to 8341370819.</p>
                                                </div>
                                                <ButtonStyle style={{ height: '40px' }} text={'Close'} className="btn" handleClick={this.applyClipPopup}></ButtonStyle>
                                            </div>
                                        </div>
                                    </Popup>
                                )}
                            </li>}
                        </ul>
                    </div>
                    <div className="col-md-4"></div>
                </div>
                <div className={`listings row ${styles.large_rect} ${styles.large_rect_margin}`}>
                    {(this.state.readOnly) ? null : <LargeRectangle spot={"-1"} />}
                </div>
                <div className={`${styles.billBoard} row`} style={{ backgroundColor: '#e5e5f2', paddingTop: '100px', paddingBottom: '100px' }}>
                    {(this.state.readOnly) ? null : <BillBoard spot={"-1"} />}
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        is_login: state.is_login,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        clearPropsData: () => dispatch({ type: 'CLEAR_DATA' }),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Qualification);